/* eslint-disable no-mixed-spaces-and-tabs */
import type { EAV } from '@fibl/zdb-common';
import type { SearchFilter } from './search';
import { get, post } from '@/util/request.js';

export type BatchAction =
	| {
			key: 'copy-to-collection';
			config: { entityClass: string };
	  }
	| {
			key: 'delete';
	  }
	| {
			key: 'add-patch';
			config: {
				patch?: EAV.JsonPatch;
				changeset?: string;
				changesetrev?: number;
				dynamicPatch?: string;
			};
	  };

export type BatchTplCreate = {
	filter: {
		entityClass: string;
		attributeFilter?: SearchFilter;
	};
	allowFilterFromJob?: boolean;
	actions: BatchAction[];
	config: Record<string, any>;
	name?: string;
	parallelProcessing?: number;
	errorHandling?: 'abort' | 'skip';
	executeAsSystem?: boolean;
};

export type BatchTplUpdate = BatchTpl;

export type BatchTpl = { id: string } & BatchTplCreate;

export function createTemplate(payload: BatchTplCreate): Promise<BatchTpl> {
	return post('batch/template/create', payload);
}

export function updateTemplate(payload: BatchTplUpdate): Promise<BatchTpl> {
	return post(
		'batch/template/update',

		payload,
	);
}

export type BatchJobRun = {
	template: string;
	config?: Record<string, any>;
	attributeFilter?: SearchFilter;
	dryRun?: boolean;
};
export type BatchError = {
	entityId?: string;
	message: string;
	service?: string;
	code?: string;
	details?: string;
	_stack?: {
		fn: string;
		file: string;
		line: number;
	}[];
	prev?: BatchError;
};
export type BatchJob = {
	id: string;
	template: {
		id: string;
		rev: number;
	};
	initiatorDomain: string;
	config?: Record<string, any>;
	status: 'new' | 'running' | 'complete' | 'aborted';
	errors?: BatchError[];
	stats: {
		initial: number;
		nochange: number;
		success: number;
		error: number;
	};
	decodedAuth?: Record<string, any>;
	attributeFilter?: SearchFilter;
	dryRun?: boolean;
};
export type BatchStatus = {
	initial: number;
	nochange: number;
	success: number;
	error: number;
	status: 'new' | 'running' | 'complete' | 'aborted';
};

export function runJob(payload: BatchJobRun): Promise<BatchJob> {
	return post('batch/job/run', payload);
}

export function getStatus(jobId: string): Promise<BatchStatus> {
	return post('batch/job/checkstatus', jobId);
}

export function getJob(jobId: string): Promise<BatchJob> {
	return post('batch/job/get', jobId);
}

export function getTemplateFromAlias(alias: string): Promise<BatchTpl> {
	return post('batch/template/getbyname', alias);
}
